export default [
  {value: 'billable', title: 'Billable'},
  {value: 'not_billable', title: 'Not billable'},
]
